<template>
    <div>
        <profileM v-if="$detect == 'mobile'"/>
        <profileW v-else/>
    </div>
</template>
<script>
export default {
    components: {
        profileM: () => import('./profileMobile.vue'),
        profileW: () => import('./profileWeb.vue'),
    },
}
</script>
<style lang="scss">
</style>
